import React from 'react';
import PropTypes from 'prop-types';

import ApiTokenListContainer from './api_token_list';
import ApiTokensZeroStateContainer from './api_tokens_zero_state';
import connect from 'components/lib/connect';

export function ApiTokensLayout({ apiTokensExist, isLoading }) {
  if (isLoading) {
    return null;
  }

  if (apiTokensExist) {
    return <ApiTokenListContainer />;
  }

  return <ApiTokensZeroStateContainer />;
}

ApiTokensLayout.propTypes = {
  apiTokensExist: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
};

export default connect(mapStateToProps)(ApiTokensLayout);

function mapStateToProps({ getProvider }) {
  let apiTokensProvider = getProvider('apiTokens');
  return {
    apiTokensExist: apiTokensProvider.count() > 0,
    isLoading: apiTokensProvider.isLoading(),
  };
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/api_tokens/api_tokens_layout.jsx